import { action, makeObservable, observable } from 'mobx';

class ProductStore {
    constructor() {
        makeObservable(this)
    }

    @observable loadingItemStatus: boolean = false;
    @action setLoadingItemStatus(status: boolean) {
        this.loadingItemStatus = status;
    }

    // Product Datas
    @observable productDatas = {};

    @action addProductData(productId: number, productData: any) {
        this.productDatas[productId] = productData;
    }

    @action updateProductData(productId: number, productData: any) {
        this.productDatas[productId] = productData;
    }
    // Product Datas

    // Products
    @observable products = {
        content: {},
        page: 1,
        pageCount: 1,
    }

    @action resetProducts() {
        this.products = {
            content: {},
            page: 1,
            pageCount: 1,
        };
    }

    @action setProducts(products: any) {
        this.products['content'] = products;
    }

    @action setPaginationData(page: number, pageCount: number) {
        this.products = {
            ...this.products,
            page,
            pageCount,
        };
    }

    @action addProduct(productId: number, productData: any) {
        this.products['content'][productId] = productData;
    }

    @action updateProduct(productId: number, productData: any) {
        if (this.products['content'][productId] !== undefined) {
            this.products['content'][productId] = productData;
        }

        if (this.productDatas[productId] !== undefined) {
            this.productDatas[productId] = productData;
        }
    }

    @action deleteProduct(productId: number) {
        delete this.products['content'][productId];
    }
    // Products

    // Search Products
    @observable searchProducts = {
        content: {},
        page: 1,
        pageCount: 1,
    };

    @action setSearchProducts(searchProducts: any) {
        this.searchProducts = searchProducts;
    }

    @action resetSearchProducts() {
        this.searchProducts = {
            content: {},
            page: 1,
            pageCount: 1,
        };
    }

    @action setSearchPaginationData(page: number, pageCount: number) {
        this.searchProducts = {
            ...this.searchProducts,
            page,
            pageCount,
        };
    }

    @action addSearchProduct(productId: number, productData: any) {
        this.searchProducts.content[productId] = productData;
    }

    @action deleteSearchProduct(productId: number) {
        if (this.searchProducts.content[productId] !== undefined) {
            delete this.searchProducts.content[productId];
        }
    }

    @observable searchFilterText = "";
    @action setSearchFilterText(filterText: string) {
        this.searchFilterText = filterText;
    }
    // Search Products
}

const store = new ProductStore();

export default store;